import Common from '../../Common';
import Data from './destination/Data';
import Entry from './destination/Entry';
import Trigger from './destination/Trigger';

const Destination = class extends Common {
	entry: InstanceType<typeof Entry>;
	trigger: InstanceType<typeof Trigger>;
	data: InstanceType<typeof Data>;

	constructor(headers: ApiHeaders) {
		super(headers)

		this.entry = new Entry(headers)
		this.trigger = new Trigger(headers)
		this.data = new Data(headers)
	}

	read = (destinationId: id) =>
		this.get(`/callback/destination/${destinationId}`)

	getBookableTimes = (destinationId: id) =>
		this.get(`/callback/destination/${destinationId}/getbookabletimes`)

	delete = (destinationId: id) =>
		this.doDelete(`/callback/destination/${destinationId}`)
}

export default Destination
